import React, { Component } from "react";
import Gallery from "../Gallery/Gallery.js";
import { ordinaled } from "../List/List.consts";

import "./Modal.css";

class Modal extends Component {
  // const isSocialMedia = (socialMediaBaseURL,mediaURL,iconClasses) => {
  //     if(!mediaURL){
  //       return null;
  //     }
  //     mediaURL.replace('@','');

  //     return (
  //       <a
  //         type='button'
  //         className='btn-floating btn-sm text-center'
  //         href={`${socialMediaBaseURL}${mediaURL.replace('@','')}`}
  //         target='_blank' rel='noopener noreferrer'>
  //         <i className={iconClasses} />
  //       </a>
  //     )

  //   }
  getInfo = infoType => {
    var { profile } = this.props.vendor;
    if (infoType === "location") {
      var location = profile.address || "Lagos, Nigeria";
      if (!location) {
        return (
          <span className="text-muted">
            <em>-</em>
          </span>
        );
      }
      return location;
    }
    if (infoType === "phone") {
      return <a href="tel:+2348000000000">08000000000</a>;
    }
    if (!infoType) {
      return (
        <span className="text-muted">
          <em>-</em>
        </span>
      );
    }
    if (infoType === "fb") {
      var facebookID =
        profile.facebook || profile.instagram || this.props.vendor.id;
      return (
        <a
          href={`https://www.facebook.com/${facebookID.replace("@", "")}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {facebookID}
        </a>
      );
    }
    if (infoType === "twitter") {
      var twitterID =
        profile.twitter || profile.instagram || this.props.vendor.id;
      return (
        <a
          href={`https://www.twitter.com/${twitterID.replace("@", "")}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {twitterID}
        </a>
      );
    }

    if (infoType === "ig") {
      var igID = profile.instagram || this.props.vendor.id;
      return (
        <a
          href={`https://www.instagram.com/${igID.replace("@", "")}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {igID}
        </a>
      );
    }
  };
  render() {
    const { closeModal, vendor } = this.props;
    var encodedAddress = vendor.profile.address
      ? encodeURIComponent(vendor.profile.address)
      : encodeURIComponent("Lagos, Nigeria");
    console.log(vendor);
    const typeRank = vendor.types[0]
      ? `No. ${vendor.typeRank} in ${vendor.types[0]} & `
      : "";
    return (
      <div
        id="modal-container"
        className="modal react-modal fade show lush-modal"
        role="dialog"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="container">
                <span className="float-left modal-title">
                  {vendor.id.replace("@", "").toUpperCase()}
                </span>
                <span className="float-right rank">
                  {`${typeRank} ${ordinaled(vendor.rank)} overall `}
                </span>
              </div>
              <button
                type="button"
                onClick={closeModal}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              className="modal-body"
              style={{ maxHeight: "calc(100vh - 210px)", overflowY: "auto" }}
            >
              <div>
                <div className="container-fluid">
                  <div className="row">
                    <Gallery vendors={vendor} />
                    <div className="col-xs-12 col-lg-4">
                      <div>
                        {vendor.types[0] ? (
                          vendor.types.map((type, index) => (
                            <div key={type}>{type.toUpperCase()}</div>
                          ))
                        ) : (
                          <span className="text-muted">
                            <em>None Added</em>
                          </span>
                        )}
                      </div>
                      <hr />
                      <p>
                        <i className="fa fa-instagram" />
                        &nbsp;: {this.getInfo("ig")}
                      </p>
                      <p>
                        <i className="fa fa-phone" />
                        &nbsp;: {this.getInfo("phone")}
                      </p>
                      <p>
                        <i className="fa fa-twitter" />
                        &nbsp;: {this.getInfo("twitter")}
                      </p>
                      <p>
                        <i className="fa fa-facebook-f" />
                        &nbsp;: {this.getInfo("fb")}
                      </p>
                      <p>
                        <i className="fa fa-map-marker" />
                        &nbsp;: {this.getInfo("location")}
                      </p>
                      <hr />
                      <h6>
                        {" "}
                        <i className="fa fa-heart rating" />
                        {"  " +
                          vendor.likes.toLocaleString(navigator.language, {
                            minimumFractionDigits: 0
                          })}{" "}
                        lush feels
                      </h6>
                      <h6>
                        {" "}
                        <i className="fa fa-edit rating" />
                        {"  " +
                          vendor.appearance.toLocaleString(navigator.language, {
                            minimumFractionDigits: 0
                          })}{" "}
                        lush weddings
                      </h6>
                      <h6>
                        {" "}
                        <i className="fa fa-comments rating" />
                        {"  " +
                          vendor.comments.toLocaleString(navigator.language, {
                            minimumFractionDigits: 0
                          })}{" "}
                        lush taps
                      </h6>
                      <hr />
                    </div>
                    <div className="float-right col-xs-12 col-lg-8">
                      <div className="mapouter">
                        <div className="gmap_canvas">
                          <iframe
                            title="Map"
                            width="100%"
                            height="300"
                            id="gmap_canvas"
                            src={`https://maps.google.com/maps?q=${encodedAddress}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
                            frameBorder="0"
                            scrolling="no"
                            marginHeight="0"
                            marginWidth="0"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <hr />
              </div>
              <div className="modal-footer center">
                <button
                  type="button"
                  className="btn btn-sm lush-btn"
                  onClick={closeModal}
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;

// export default class Modal extends Component {
//     render(){
//         return(
//         )
//     }
// }



// WEBPACK FOOTER //
// ./src/Modal/Modal.js